/**
 * `fetch` wrapper that aborts and rejects after `timeoutMs` instead of hanging forever.
 *
 * See #225: a stalled/slow mobile connection uploading a large presentation file left the plain
 * `fetch()` promise pending indefinitely — the UI showed a disabled "Submit" button with no error,
 * indistinguishable from a successful-but-slow upload. A bounded timeout guarantees the caller's
 * `catch` eventually runs so the user gets feedback instead of a silently stuck button.
 */
export async function fetchWithTimeout(
  input: string,
  init: RequestInit = {},
  timeoutMs = 60_000
): Promise<Response> {
  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), timeoutMs)
  try {
    return await fetch(input, { ...init, signal: controller.signal })
  } finally {
    clearTimeout(timer)
  }
}
